import type BookingServiceCustomQuestionType from 'owa-service/lib/contract/BookingServiceCustomQuestionType';
import type { BookingQuestionAssignment } from 'owa-graph-schema';

const mapBookingQuestionAssignment = (
    customQuestions: BookingQuestionAssignment[] | null | undefined
): BookingServiceCustomQuestionType[] | undefined => {
    if (!customQuestions) {
        return;
    }
    const modifiedCustomQuestions: BookingServiceCustomQuestionType[] =
        customQuestions?.map(({ questionGuid, required }) => ({
            QuestionGuid: questionGuid ?? '',
            Required: required ?? false,
        })) ?? [];
    return modifiedCustomQuestions;
};

export default mapBookingQuestionAssignment;
